import {Component, inject, OnInit} from '@angular/core';
import {ScreenLockService} from '../../../core/services/screen-lock.service';
import {DialogModule} from 'primeng/dialog';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MessageModule} from 'primeng/message';
import {Router} from '@angular/router';
import {LoginResult} from '../../../core/interfaces/login-result-interface';
import {AuthService} from '../../../core/auth/auth-service';
import {AuthSessionState} from '../../../core/auth/auth-session.state';
import {IconField} from 'primeng/iconfield';
import {InputIcon} from 'primeng/inputicon';
import {Password} from 'primeng/password';

import {DbStore} from '../../../core/db/models/db-store.model';
import {StoreDbService} from '../../../core/db/store.db.service';
import {LayoutService} from '../../../core/services/layout.service';
import {InformacionTiendaSoporte} from '../informacion-tienda-soporte/informacion-tienda-soporte';
import {LoadingService} from '../loading/loading.service';
import {of, switchMap} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-login-modal-autorice',
  imports: [
    DialogModule,
    InputTextModule,
    ButtonModule,
    FormsModule,
    MessageModule,
    IconField,
    InputIcon,
    Password,
    ReactiveFormsModule,
    InformacionTiendaSoporte
  ],
  templateUrl: './login-modal-autorice.html',
  styleUrl: './login-modal-autorice.scss',
  standalone: true,
})
export class LoginModalAutorice implements OnInit {
  router = inject(Router);
  screenLock = inject(ScreenLockService);
  // security = inject(Security);
  private authService = inject(AuthService);
  private session = inject(AuthSessionState);
  private loadingService = inject(LoadingService);
  private storeDbService = inject(StoreDbService);
  public layoutService = inject(LayoutService);

  store: DbStore | undefined;
  form: FormGroup;
  private fb = new FormBuilder();
  errorMessage = '';
  proceso!: string;
  pais!: string;
  constructor() {
    this.form = this.fb.group({
      usuario: ['', [Validators.required]],
      password: ['', Validators.required],
    });
  }

  async ngOnInit() {
    this.store = await this.storeDbService.getConfig();

    this.pais = this.store?.pais ?? '';
    this.proceso = this.screenLock.proceso()!;
  }


  login() {
    if (this.form.invalid) return;
    this.loadingService.show();
    const { usuario, password } = this.form.value;
    const store = this.store;

    if (!store) {
      this.errorMessage = 'No fue posible obtener la configuraciónn de la tienda.';
      this.loadingService.hide();
      return;
    }

    const autorizacion$ = environment.securityVersion === 2
      ? this.authService.loginBackedWithEmailAndPassword(
          usuario,
          password,
          store.puntoVenta,
          store.pais,
          store.tipoPV
        ).pipe(
          switchMap(response => response.ok
            ? this.authService.verificarUsuarioProceso(usuario, password, this.pais, this.proceso)
            : of(response)
          )
        )
      : this.authService.verificarUsuarioProceso(
          usuario,
          password,
          this.pais,
          this.proceso
        );

    autorizacion$.subscribe({
        next: async (response: LoginResult) => {
          if (!response.ok) {
            this.errorMessage = this.extractErrorMessage(response.exception);
            this.loadingService.hide();
            return;
          }
          if(response.token){
            const token = response.token;
            const user = response.claims!;
            const raw = response.rawBackend;
            if (!raw) {
              // this.errorMessage = 'Sesión inválida';
              // this.loading.set(false);
              // this.loadingService.hide();
              return;
            }
            await this.session.setBackendSession(token, user, raw);
            // Resetear IndexedDB
            await this.authService.persistSessionData(raw,user.user_id);
            // Autorizar solamente el reintento de la pantalla solicitada.
            const url = this.screenLock.authorizePending();

            if (url) {
              this.router.navigateByUrl(url,{ state: {skipConfirm: true} })
                .finally(() => this.screenLock.clear());
            }
          } else if (response.exception){
          //   this.errorMessage = this.extractErrorMessage(response.exception);
          }
          // // this.loading.set(false);
          // this.loadingService.hide();
          this.loadingService.hide();
        },
        error: err => {
          console.error(err);
          this.errorMessage = 'No pudimos verificar tu usuario, intenta de nuevo.';
          this.loadingService.hide();
        }
      });
  }
  cancel(): void {
    this.screenLock.unlock();
    this.screenLock.clear();
    this.layoutService.closeSidebar();
    this.router.navigate(['/dashboard'], {
      replaceUrl: true,
      state: {skipConfirm: true},
    });
  }

  private extractErrorMessage(error: unknown): string {

    if (error instanceof Error) {
      return error.message;
    }

    if (typeof error === 'string') {
      return error;
    }

    if (
      typeof error === 'object' &&
      error !== null &&
      'message' in error &&
      typeof (error as { message?: unknown }).message === 'string'
    ) {
      if(error.message === 'Servicio NO Disponible, intente más tarde'){
        return 'No pudimos verificar tu usuario, intenta de nuevo.';
      } else {
        return (error as { message: string }).message;
      }
    }

    return 'Error inesperado';
  }
}

